import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Chatbot = lazy(() => import("./Chatbot"));
const ActivityNotifications = lazy(() => import("./ActivityNotifications"));


const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1 pt-16">{children}</main>
    <Footer />
    <Suspense fallback={null}>
      <Chatbot />
      <ActivityNotifications />
    </Suspense>
  </div>
);

export default Layout;
